import { AddFilled, Delete20Regular } from "@fluentui/react-icons";
import React from "react";
import "../Home.css";
import { v4 as uuid } from "uuid";
import Select from "react-select";
import axios from "axios";
import { Checkbox, Dropdown, Label, PrimaryButton, TextField } from "office-ui-fabric-react";
import { checkboxStyles, customStyles, getTaskDueDate, SelectTheme } from "../Global/Constant";
import { SweetAlerts } from "../Global/SweetAlert";
import {
  createReviewDocsForUsers,
  downloadFileBlob,
  generateDocumentsForUsers,
  getFileById,
  getSelectedText,
  postTaskInBatch,
  readCurrentDocument,
  updateListData,
  uploadFilesInBatch,
} from "../../Utils/CommonFunctions";
// import { Web } from "sp-pnp-js";
import ContextService from "../../services/ContextService";
interface IAddReview {
  AssignedTo: any;
  HighlightedText: any;
  Status: any;
  TaskGUID: any;
  checked: any;
  comments: any;
}
function SendReview({ FileName, RequestListData }) {
  // console.log(FileName, RequestListData);
  const [sendReviewData, setSendReviewData] = React.useState<any>([]);
    const [SumbitLoader, setSumbitsetLoader] = React.useState(false);
  const [userOptions, setUserOptions] = React.useState([]);
  const { SweetAlert: SweetAlertAddReview } = SweetAlerts("#addReview");
  React.useEffect(() => {
    const UserOptions = JSON.parse(localStorage.getItem("AllUsers") || "[]");
    // console.log(UserOptions);
    setUserOptions(UserOptions);
  }, []);

  const handleAddReview = async () => {
    const ReviewLastIndex = sendReviewData?.length - 1;
    const selectedText = await getSelectedText();
    if (!selectedText?.text?.trim()) {
      SweetAlertAddReview("error", "Please select the text to add");
      return;
    }
    if (sendReviewData[ReviewLastIndex]?.AssignedTo?.length == 0 && ReviewLastIndex != -1) {
      SweetAlertAddReview("error", "Please select assign to");
      return;
    }
    const isTextAlreadyReviewed = sendReviewData?.some(
      (data) => data.HighlightedText?.trim().toLowerCase() === selectedText?.text?.trim().toLowerCase()
    );
    if (isTextAlreadyReviewed) {
      SweetAlertAddReview("error", "The selected text already exists. Please select different text.");
      return;
    }

    if (ReviewLastIndex != -1) {
      const lastReview = sendReviewData[ReviewLastIndex];
      await Word.run(async (context) => {
        const paragraphIndex = lastReview?.ParagraphIndex;

        if (typeof paragraphIndex !== "number") {
          console.error("Invalid or missing ParagraphIndex.");
          return;
        }

        const paragraphs = context.document.body.paragraphs;
        paragraphs.load("items");

        await context.sync();

        if (paragraphIndex >= paragraphs.items.length) {
          console.error("ParagraphIndex is out of range.");
          return;
        }

        const targetParagraph = paragraphs.items[paragraphIndex];
        targetParagraph.font.highlightColor = "yellow";

        await context.sync();
      });

      // const currentDocument=await readCurrentDocument();
      // const file = new File([currentDocument], lastReview?.TaskGUID, {
      //   type: currentDocument.type,
      //  lastModified: Date.now()
      //   });
      // console.log(currentDocument,'currentDocument')
      //  const updated = [...sendReviewData];
      //   updated[ReviewLastIndex].File =file;
      //   setSendReviewData(updated);
    }

    const uniqueGUID = uuid();
    // await Word.run(async (context) => {
    //   const selection = context.document.getSelection();
    //   const contentControl = selection.insertContentControl();
    //   contentControl.title = uniqueGUID;
    //   contentControl.tag = uniqueGUID;
    //   await context.sync();
    // });

    const newReview = {
      AssignedTo: [],
      HighlightedText: selectedText?.text,
      Status: "Not Started",
      TaskGUID: uniqueGUID,
      checked: false,
      comments: "",
      ParagraphIndex: selectedText?.ParagraphIndex,
      StartIndex: selectedText?.StartIndex,
      EndIndex: selectedText?.EndIndex,
    };

    setSendReviewData((c) => {
      return [...c, newReview];
    });
    // console.log(sendReviewData, "sendReviewData");
  };

  const handleDeleteReview = async (index, data) => {
    await Word.run(async (context) => {
      const paragraphIndex = data?.ParagraphIndex;

      if (typeof paragraphIndex !== "number") {
        console.error("Invalid or missing ParagraphIndex.");
        return;
      }

      const paragraphs = context.document.body.paragraphs;
      paragraphs.load("items");

      await context.sync();

      if (paragraphIndex >= paragraphs.items.length) {
        console.error("ParagraphIndex is out of range.");
        return;
      }

      const targetParagraph = paragraphs.items[paragraphIndex];
      targetParagraph.font.highlightColor = "";

      await context.sync();
    });
    setSendReviewData((prev) => prev.filter((_, i) => i !== index));
    SweetAlertAddReview("success", "Deleted Successfully!");
  };

  const onAssignedToChange = (select, index) => {
    const updated = [...sendReviewData];
    updated[index].AssignedTo = [...select];
    setSendReviewData(updated);
  };

  const onSubmitReview = async () => {
    type HighlightInfo = {
      text: string;
      ParagraphIndex: number | null;
      StartIndex: number | null;
      Comments: string;
    };
    const reviewItems = [...sendReviewData];
    // console.log(reviewItems, "reviewItems");
    if (reviewItems?.length) {
      const userHighlightsMap: { [email: string]: HighlightInfo[] } = {};
      const allUsers = [];
      const seenUserKeys = new Set();
      reviewItems.forEach((item) => {
        item.AssignedTo.forEach((user) => {
          if (!seenUserKeys.has(user.key)) {
            seenUserKeys.add(user.key);
            allUsers.push(user);
          }
          if (!userHighlightsMap[user.key]) {
            userHighlightsMap[user.key] = [];
          }

          userHighlightsMap[user.key].push({
            text: item.HighlightedText,
            ParagraphIndex: item?.ParagraphIndex ?? null,
            StartIndex: item?.StartIndex ?? null,
            Comments: item?.comments,
          });
        });
      });
      // console.log(userHighlightsMap, "userHighlightsMap");

      const fileInfo = await getFileById(FileName);
      const serverRelativeUrl = fileInfo?.ServerRelativeUrl;

      if (!serverRelativeUrl) {
        console.error("No file found for:", FileName);
        return;
      }


      const fileBlob = await downloadFileBlob(serverRelativeUrl);
      const allUserFiles = await generateDocumentsForUsers(userHighlightsMap, fileBlob);
      // console.log(allUserFiles, "allUserFiles");
      if (allUserFiles?.length) {
        let currentRequestStage = "";
        if (RequestListData?.Status == "Legal Review") {
          currentRequestStage = "Legal Review";
        } else if (RequestListData?.["Negotiation"] == "Pending") {
          currentRequestStage = "Negotiation";
        } else if (RequestListData?.["RequestApproval"] == "Pending" && RequestListData?.["Negotiation"] != "Pending") {
          currentRequestStage = "Business Approval";
        } else if (
          RequestListData?.["RequestApproval"] == "Completed" &&
          RequestListData?.["Negotiation"] != "Pending" &&
          RequestListData?.["DraftApproval"] == "Not Started"
        ) {
          currentRequestStage = "Business Approval";
        } else if (RequestListData?.["DraftApproval"] == "Pending" && RequestListData?.["Negotiation"] != "Pending") {
          currentRequestStage = "Legal Review";
        } else if (
          RequestListData?.["RequestApproval"] == "Completed" &&
          RequestListData?.["DraftApproval"] == "Completed" &&
          RequestListData?.["Negotiation"] != "Pending" &&
          RequestListData?.["ExecutionApproval"] == "Not Started"
        ) {
          currentRequestStage = "Legal Review";
        } else if (
          RequestListData?.["RequestApproval"] == "Completed" &&
          RequestListData?.["DraftApproval"] == "Completed" &&
          RequestListData?.["ExecutionApproval"] == "Pending"
        ) {
          currentRequestStage = "Execution Approval";
        }
        const currentUserDetails = JSON.parse(localStorage.getItem("CurrentUser") || "{}");
        const allReviewTasks = [];
        const allReviewTaskDocuments = [];
        const Activity_logs = JSON.parse(RequestListData?.Activity_Log || "[]");
        allUsers?.map((user) => {
          const userReview = userHighlightsMap[user?.key] || [];
          const uniqueGUID = uuid();
          const finaltaskTemplate = {
            Title: "Review Task from Word",
            ContractType: RequestListData?.Contract_Type,
            RequestType: "Contract",
            Task_Type: "Review Task Word AddIn",
            BusinessUnit: RequestListData?.Business_Unit,
            Status: "Not Started",
            DueDate: getTaskDueDate(),
            TaskStage: currentRequestStage,
            AssignedToId: [user?.id],
            RequestGuid: RequestListData?.Guid_ID,
            Contract_Request_Title: RequestListData?.Title,
            TaskGuid: uniqueGUID,
            Other_Actions: JSON.stringify({
              OnRejection: "",
              DueDays: "",
              EditCheck: "",
              HoldCheck: "",
              DraftUpload: "",
            }),
            LevelStage: currentRequestStage,
            ParentTaskGUID: RequestListData?.Guid_ID,
          };

          const filterDocument = allUserFiles?.filter((document) => document.userEmail == user?.key);
          const blob = filterDocument[0]?.Blob;
          const file = new File([blob], "review_approval_document.docx", {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          const filename = uniqueGUID + "." + file?.name.split(".")[1];
          const finalDocumentTemp = {
            GUID: filename,
            FileName: file?.name,
            FileContent: file,
          };
          const allUserReviews = userReview
            ?.map((ele) => {
              const highlightHTML = `<p><span style="background-color: rgb(255, 255, 0); color: rgb(0, 0, 0);">${ele.text}</span><span style="color: rgb(0, 0, 0);">&nbsp;</span></p>`;
              const commentHTML = ele.Comments ? `<p>Comments: ${ele.Comments}</p><p><br></p>` : "";
              const fullHTML = highlightHTML + commentHTML;
              return encodeURIComponent(fullHTML);
            })
            .join("");
          const reviewActivity = {
            Activity: "Review Task Approval",
            Description: `Review Task request received for ${user?.text} from ${currentUserDetails?.currentUserName}.`,
            CreatedOn: new Date(),
            CreatedBy: currentUserDetails?.currentUserName,
            CreatedByEmail: currentUserDetails?.currentUserEmail,
            Reasons: "",
            Remarks: allUserReviews,
            Attachments: uniqueGUID,
            Approvers: [],
            Originator: [currentUserDetails?.currentUserName],
            receivedUser: [],
            Contract_Type: "",
          };
          Activity_logs.push(reviewActivity);
          allReviewTaskDocuments.push(finalDocumentTemp);
          allReviewTasks.push(finaltaskTemplate);
        });

        await postTaskInBatch(allReviewTasks);
        await uploadFilesInBatch(allReviewTaskDocuments, RequestListData?.Guid_ID);

        const finalRequestTemp = {
          Activity_Log: JSON.stringify(Activity_logs),
        };
        await updateListData(RequestListData?.Id, finalRequestTemp, "CLM365Request");
        // console.log(allReviewTasks, "all Review Tasks");
        SweetAlertAddReview("success", "Submitted Successfully!");
        setTimeout(() => {
          setSendReviewData([]);
        }, 3000);
      }
    } else {
      SweetAlertAddReview("error", "Please add review to submit.");
    }
  };

  return (
    <div id="addReview">
      {sendReviewData?.map((data, index) => {
        return (
          <div key={index} className="addReviewBox">
            <div style={{ display: "flex", gap: "3px" }}>
              {/* <Checkbox
                key={index}
                checked={data?.checked}
                styles={checkboxStyles}
                onChange={(_, checked) => {
                  const updated = [...sendReviewData];
                  updated[index].checked = checked;
                  setSendReviewData(updated);
                }}
              /> */}
              <span>{data?.HighlightedText}</span>
            </div>
            <div style={{ margin: "5px 0px" }}>
              <TextField
                placeholder="Enter comment"
                value={data?.comments}
                title="Comment"
                onChange={(_, comments) => {
                  const updated = [...sendReviewData];
                  updated[index].comments = comments;
                  setSendReviewData(updated);
                }}
                multiline
                rowSpan={3}
              />
            </div>
            <div>
              <Select
                placeholder={"Select assign to"}
                theme={SelectTheme}
                options={userOptions}
                
                value={userOptions.filter((el) => data?.AssignedTo?.some((f) => f.id === el.id))}
                isSearchable={true}
                isMulti={true}
                onChange={(select) => onAssignedToChange(select, index)}
                styles={customStyles}
              />
            </div>
            <div style={{ paddingTop: "10px" }}>
              <Delete20Regular onClick={() => handleDeleteReview(index, data)} />
            </div>
          </div>
        );
      })}
      <div style={{ display: "flex", justifyContent: sendReviewData?.length ? "end" : "start" }}>
        <div className="AddReviewBtn" onClick={handleAddReview}>
          <AddFilled />
          <span>Review</span>
        </div>
      </div>

      {sendReviewData?.length ? (
        <div style={{ marginTop: "10px" }}>
          <PrimaryButton text="Submit" onClick={onSubmitReview} disabled={SumbitLoader} />
        </div>
      ) : null}
    </div>
  );
}

export default SendReview;
